<template>
  <div class="home">
    <div class="banner">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="@/assets/banner1.jpg" />
          </div>
        </div>
      </div>

      <!-- 左右按钮 -->
    </div>
    <div class="entry-wrap">
      <div class="entry-1200">
        <div class="entry-item" v-for="item in entryList" :key="item.path" @click="$router.push(item.path)">
          <div class="img-box">
            <img :src="item.img" />
          </div>
          <div class="info">
            <div class="title">
              <span class="bar"></span>
              {{ item.title }}
            </div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="order-flow">
      <div class="title">自助下单流程</div>
      <div class="title">
        <p>需先注册登录，可微信扫码一键注册</p>
      </div>

      <el-steps align-center :active="4">
        <el-step title="自助报价" description="填写尺寸、材料、工艺后自动报价" icon="el-icon-document" />
        <el-step title="上传文件" description="上传印刷文稿" icon="el-icon-upload" />
        <el-step title="支付货款" description="微信 / 支付宝 / 银行卡" icon="el-icon-wallet" />
        <el-step title="自取" description="工厂自提自提" icon="el-icon-truck" />
      </el-steps>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/css/swiper.css'
import icon1 from '@/assets/icon1.jpg'
import icon2 from '@/assets/icon2.jpg'
import icon3 from '@/assets/icon3.jpg'
import icon4 from '@/assets/icon4.jpg'
export default {
  name: 'HomeView',
  mounted() {
    new Swiper('.swiper-container')
  },
  data() {
    return {
      entryList: [
        {
          title: '卷装标签',
          desc: '合适 四色+专色，可变数据，烫金，UV，可平张',
          path: '/offer',
          img: icon1
        },
        {
          title: '卷装亮银，透明标签',
          desc: '合适 白+4色+专色工艺，可变数据，烫金，UV，可平张',
          path: '/offer2',
          img: icon2
        },
        {
          title: '黑白不干胶',
          desc: '合适简单黑白色印刷，无工艺。可卷可平张',
          path: '/offer3',
          img: icon3
        },
        {
          title: '有问有答',
          desc: '解答 数码印刷费用和质量工艺问题',
          path: '/ask',
          img: icon4
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  // height: 46px;
  max-width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.entry-wrap {
  background: #fff;
  padding: 40px 0;

  .entry-1200 {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    .entry-item {
      width: 23%;
      cursor: pointer;
      background: #f8f8f8;
      transition: all 0.3s;

      &:hover {
        transform: translateY(-6px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
      }

      .img-box {
        img {
          width: 100%;
          height: 200px;
          object-fit: cover;
        }
      }

      .info {
        padding: 18px;

        .title {
          font-size: 18px;
          font-weight: bold;
          display: flex;
          align-items: center;

          .bar {
            width: 4px;
            height: 18px;
            background: #409eff;
            margin-right: 8px;
          }
        }

        .desc {
          margin-top: 10px;
          font-size: 14px;
          color: #666;
          line-height: 1.6;
        }
      }
    }
  }
}

.order-flow {
  max-width: 1200px;
  margin: 100px auto;
  text-align: center;

  .title {
    font-size: 36px;
    font-weight: bold;
    color: #333;

    p {
      font-size: 16px;
      color: #666;
      margin-top: 10px;
      position: relative;
      display: inline-block;

      &::before,
      &::after {
        content: '';
        width: 120px;
        height: 1px;
        background: #ddd;
        position: absolute;
        top: 50%;
      }

      &::before {
        left: -140px;
      }

      &::after {
        right: -140px;
      }
    }
  }

  .el-steps {
    margin-top: 60px;
  }

  .el-step__title {
    font-size: 18px;
    font-weight: bold;
  }

  .el-step__description {
    font-size: 14px;
    line-height: 1.6;
  }

  .el-step__icon {
    font-size: 28px;
  }
}
</style>
